// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"f661d29d","580":"35edc02d"}[chunkId] + ".chunk.js";
};